'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "96 Kuli Maratha Vadhu Var Suchak Mandal Pune" },
  { label: "Maratha Vadhu" },
  { label: "96 Kuli Maratha Vadhu Var WhatsApp group link" },
  { label: "Maratha Vadhu Var Suchak Kendra Nashik" },
  { label: "96 Kuli Maratha Vadhu" },
  { label: "Maratha Vadhu Var Suchak Kendra Pune" },
  { label: "Maratha Vadhu Var Photo" },
  { label: "Solapur Maratha Vadhu Var Suchak Whatsapp Group" },
  { label: "Maratha Vadhu Var Suchak Kendra Kolhapur" },
  { label: "Maratha Vadhu Var Suchak Kendra Solapur" },
  { label: "Maratha Vadhu Var Suchak Kendra" },
  { label: "Free Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha Vadhu Var Suchak Mandal Pune" },
  { label: "Maratha Vadhu Photo Girl" },
  { label: "96 Kuli Maratha Vadhu Var Suchak Mandal Mumbai" },
  { label: "Maratha Vadhu Var Suchak Kendra Karad" },
  { label: "Maratha Vadhu Photo" },
  { label: "Maratha Vadhu Var Suchak Kandra" },
  { label: "Maratha Vadhu Var Suchak Mandal Mumbai" },
  { label: "Maratha Vadhu Var Suchak Mandal Jalgaon" },
  { label: "Maratha Vadhu Var Suchak Mandal Satara" },
  { label: "Maratha Vadhu Var Suchak Mandal Sangli" },
  { label: "Maratha Vadhu Var Suchak Mandal Sambhaji Nagar" },
];

export default function MarathaVadhuVarSuchakKendra() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="maratha_vadhu_var_suchak_kendra"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best Maratha matrimonial site for Maratha?",
                  answer: "MarathiVadhuVarSuchak.com site and mobile app is the most trusted Maratha Matrimony for Maratha community Vadhu Var."
                },
                {
                  question: "Which is the best free Maratha Matrimony site and app in Maharashtra?",
                  answer: "For Maratha community brides and grooms MarathiVadhuVarSuchak.com site is the best option for free registration."
                },
                {
                  question: "How to search Maratha Sthal on Vadhu Var Suchak Kendra site?",
                  answer: "First Maratha Vadhu Var has to register free on MarathiVadhuVarSuchak.com site and then after profile approval you can search Sthal from the Maratha community."
                },
                {
                  question: "How to sign up for Vadhu Var Suchak Maratha Matrimony search?",
                  answer: "To search 96 Kuli Maratha community brides and grooms first visit MarathiVadhuVarSuchak.com Marathi matrimony site to sign up for free."
                },
                {
                  question: "How to register profile on Maratha Vadhu Var Suchak Mandal site?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony site is the best app for Maratha brides and grooms search. Download the iOS and Android mobile app for free sign up."
                },
                {
                  question: "How to search Maratha grooms online?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony site to register first and then after profile approval Maratha brides can search groom profiles online."
                },
                {
                  question: "How to do Maratha bride Search free?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony site to register first. Then after profile approval Maratha grooms can search bride profiles online."
                },
                {
                  question: "How can the Maratha marriage bureau help for marriage?",
                  answer: "To find brides and grooms from Maratha Samaj you can register free on MarathiVadhuVarSuchak.com a trusted Marathi marriage bureau site."
                },
                {
                  question: "How to get a Maratha Brides list online?",
                  answer: "Visit MarathiVadhuVarSuchak.com a trusted Marathi matrimony site to download Maratha Brides list online."
                },
                {
                  question: "How to fill-up a Maratha registration form online?",
                  answer: "To fill-up registration form online first visit MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "How to download Maratha bride search free pdf?",
                  answer: "To get a list of Maratha brides first visit MarathiVadhuVarSuchak.com matrimony to sign-up free."
                },
                {
                  question: "How to search Maratha grooms photos online?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony site is free for registration. After profile approval Maratha brides can search Maratha grooms photos online with full profile details."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Maratha matrimony for 96 Kuli Maratha Community"
        items={communityServices}
      />

    </div>
  );
}

